import App from '../App'

const Index = r => require.ensure([], () => r(require('../views/index/index')), 'Index')
const Confirm = r => require.ensure([], () => r(require('../views/confirm/index')), 'Confirm') 
const pddBuyDetail = r => require.ensure([], () => r(require('../views/detail/pddBuy/index')), 'pddBuyDetail')
const pddFreeDetail = r => require.ensure([], () => r(require('../views/detail/pddFree/index')), 'pddFreeDetail')
const killDetail = r => require.ensure([], () => r(require('../views/detail/kill/index')), 'KillDetail')

export default [{
    path: '/',
    component: App,
    children: [{
        path: '',
        redirect: '/index'
    }, {
        path: '/index',
        name: 'index',
        component: Index
    }, {
        path: '/confirm',
        name: 'confirm',
        component: Confirm
    }, {
        path: '/killDetail',
        name: 'killDetail',
        component: killDetail
    }, {
        path: '/pddFreeDetail',
        name: 'pddFreeDetail',
        component: pddFreeDetail
    }, {
        path: '/pddBuyDetail',
        name: 'pddBuyDetail',
        component: pddBuyDetail
    }]
}]

